let createDOMElement = (xml) => {
  var parser = new DOMParser();
  var doc = parser.parseFromString(xml, "application/xml");
  return doc;
};

let readFile = async (e) => {
  return new Promise((resolve, reject) => {
    let library = {
      tracks: [],
      playlists: [],
      meta: {},
    };
    let createLibraryMeta = (dom, index) => {
      let key = dom.children[index].textContent.replaceAll('"', "");
      let value = dom.children[index + 1];
      if (value.tagName === "true" || value.tagName === "false") {
        value = value.tagName;
      } else {
        value = value.textContent;
      }
      library.meta[key] = value;
    };
    let createLibraryTracks = (dom) => {
      for (let i = 0; i < dom.children.length - 1; i += 2) {
        let track = {};
        for (let n = 0; n < dom.children[i + 1].children.length - 1; n += 2) {
          let trackDetailName = dom.children[i + 1].children[n].textContent;
          let trackDetail = dom.children[i + 1].children[n + 1].textContent;
          track[trackDetailName] = trackDetail;
        }
        library.tracks.push(track);
      }
    };

    let createLibraryPlaylists = (dom) => {
      let playlist = {};
      for (let i = 0; i < dom.children.length; i++) {
        let playlistElement = dom.children[i];
        for (let n = 0; n < playlistElement.children.length - 1; n += 2) {
          let playlistElementDetailName =
            playlistElement.children[n].textContent;
          let playlistElementDetailValue = playlistElement.children[n + 1];
          let value;
          if (
            playlistElementDetailValue.tagName === "true" ||
            playlistElementDetailValue.tagName === "false"
          ) {
            value = playlistElementDetailValue.tagName;
          } else if (playlistElementDetailValue.tagName === "array") {
            let tracks = [];
            for (
              let y = 0;
              y < playlistElementDetailValue.children.length;
              y++
            ) {
              let track = {};
              const playlistElementDetailMap =
                playlistElementDetailValue.children[y];
              for (
                let z = 0;
                z < playlistElementDetailMap.children.length - 1;
                z += 2
              ) {
                const key = playlistElementDetailMap.children[z].textContent;
                let trackId =
                  playlistElementDetailMap.children[z + 1].textContent;
                track[key] = trackId;
                tracks.push(track);
              }
              value = tracks;
            }
          } else {
            value = playlistElementDetailValue.textContent;
          }
          playlist[playlistElementDetailName] = value;
        }
        library.playlists.push({ ...playlist });
      }
    };

    let file = e.target.files[0];
    var reader = new FileReader();
    reader.onload = (e) => {
      let readXML = e.target.result;
      let doc = createDOMElement(readXML);
      const child = doc.children[0];
      if (child.nodeName === "plist") {
        let playlistNode = child;
        let playlistChildren = playlistNode.children[0];
        if (playlistChildren.nodeType === 1) {
          for (let x = 0; x < playlistChildren.children.length - 1; x += 2) {
            switch (playlistChildren.children[x + 1].tagName) {
              case "array":
                createLibraryPlaylists(playlistChildren.children[x + 1]);
                break;
              case "dict":
                createLibraryTracks(playlistChildren.children[x + 1]);
                break;
              default:
                createLibraryMeta(playlistChildren, x);
                break;
            }
          }
        }
      }
      resolve(library);
    };
    reader.onerror = (e) => {
      reject(e);
    };
    reader.readAsText(file);
  });
};

let createPlaylistFile = (form, event, libraryMeta) => {
  let createTrackDetails = (tracks) => {
    let tracksString = "";
    tracks.forEach((track) => {
      let trackString = `<key>${track["Track ID"]}</key>
		<dict>`;
      Object.entries(track).forEach((entry) => {
        const [key, value] = entry;
        if (
          [
            "Track ID",
            "Minor Version",
            "Size",
            "Total Time",
            "Disc Number",
            "Disc Count",
            "Track Number",
            "Track Count",
            "Year",
            "Normalization",
            "Bit Rate",
            "Sample Rate",
            "Artwork Count",
            "File Folder Count",
            "Library Folder Count",
          ].includes(key)
        ) {
          trackString =
            trackString + `<key>${key}</key><integer>${value}</integer>`;
        } else if (value === "true" || value === "false") {
          trackString = trackString + `<key>${key}</key></true>`;
        } else if (
          [
            "Name",
            "Artist",
            "Album Artist",
            "Album",
            "Composer",
            "Genre",
            "Kind",
            "Sort Album",
            "Sort Artist",
            "Sort Name",
            "Persistent ID",
            "Purchased",
            "Track Type",
            "Location",
          ].includes(key)
        ) {
          trackString =
            trackString +
            `<key>${key}</key><string>${value.replaceAll(
              "&",
              "&#38;"
            )}</string>`;
        } else if (
          ["Date Modified", "Date Added", "Release Date"].includes(key)
        ) {
          trackString = trackString + `<key>${key}</key><date>${value}</date>`;
        } else {
          return;
        }
      });
      tracksString = tracksString + trackString + `</dict>`;
    });
    return tracksString;
  };
  let createTrackIds = (tracks) => {
    let tracksString = "";
    tracks.forEach((track) => {
      tracksString =
        tracksString +
        `	<dict>
					<key>Track ID</key><integer>${track["Track ID"]}</integer>
				</dict>`;
    });
    return tracksString;
  };
  let libraryMatches = () => {
    let array = [];
    if (form.streamingTracks) {
      array.push(...form.streamingTracks);
    }
    array.push(...form.fields);
    return array
      .map((x) => {
        if (x.libraryMatch) {
          return x.libraryMatch;
        } else {
          return;
        }
      })
      .filter((x) => {
        return x;
      });
  };
  let iTunesPlaylistXML = `<?xml version="1.0" encoding="UTF-8"?>
        <!DOCTYPE plist  PUBLIC "-//Apple Computer//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
        <plist version="1.0">
        <dict>
          <key>Major Version</key><integer>${
            libraryMeta["Major Version"]
          }</integer>
          <key>Minor Version</key><integer>${
            libraryMeta["Minor Version"]
          }</integer>
          <key>Date</key><date>${new Date().toISOString()}</date>
          <key>Application Version</key><string>${
            libraryMeta["Application Version"]
          }</string>
          <key>Features</key><integer>${libraryMeta["Features"]}</integer>
          <key>Show Content Ratings</key><${
            libraryMeta["Show Content Ratings"]
          }/>
          <key>Music Folder</key><string>${libraryMeta["Music Folder"]}</string>
          <key>Library Persistent ID</key><string>${
            libraryMeta["Library Persistent ID"]
          }</string>
          <key>Tracks</key>
          <dict>
          ${createTrackDetails(libraryMatches())}
          </dict>
          <key>Playlists</key>
          <array>
            <dict>
              <key>Name</key><string>${event.title} - ${form.name}</string>
              <key>Description</key><string>${event.title} - ${
    form.name
  }, generated by Spin, a Simple City Software product designed specifically for DJs.</string>
              <key>Playlist ID</key><integer>${Date.now()}</integer>
              <key>Playlist Persistent ID</key><string>${Date.now()}</string>
              <key>All Items</key><true/>
              <key>Playlist Items</key>
              <array>
              ${createTrackIds(libraryMatches())}
              </array>
            </dict>
          </array>
        </dict>
        </plist>
        `;
  let fileName =
    event.title.replaceAll(/[^\w\s]/gi, "") +
    form.name.replaceAll(/[^\w\s]/gi, "") +
    ".xml";
  var pom = document.createElement("a");
  var bb = new Blob([iTunesPlaylistXML], { type: "text/plain" });

  pom.setAttribute("href", window.URL.createObjectURL(bb));
  pom.setAttribute("download", fileName);

  pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
  pom.draggable = true;
  pom.classList.add("dragout");

  pom.click();
};

export { readFile, createPlaylistFile };
